import { ref, set } from "firebase/database";
import { db } from "../../firebase";
import handleToast from "../Toast";

export const handleSaveBannerInHtmlNudge = (
  nudgeData,
  customizeState,
  nudgePosition,
  user,
  nudgeName
) => {
  // state of first time nudge to
  let state = {
    nudgeOfferText: {
      ...nudgeData.nudgeOfferText,
      customizeProperties: {
        ...nudgeData.nudgeOfferText.customizeProperties,
        text: {
          ...nudgeData.nudgeOfferText.customizeProperties.text,
          propertyValue: customizeState.nudgeOfferText.text,
        },
        textColor: {
          ...nudgeData.nudgeOfferText.customizeProperties.textColor,
          propertyValue: customizeState.nudgeOfferText.textColor,
        },
        fontStyle: {
          ...nudgeData.nudgeOfferText.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeOfferText.fontStyle,
        },
        isExpiryTimer: {
          ...nudgeData.nudgeOfferText.customizeProperties.isExpiryTimer,
          propertyValue: customizeState.nudgeOfferText.isExpiryTimer,
        },
        minutes: {
          ...nudgeData.nudgeOfferText.customizeProperties.minutes,
          propertyValue: customizeState.nudgeOfferText.minutes,
        },
      },
    },
    nudgeCouponCode: {
      ...nudgeData.nudgeCouponCode,
      customizeProperties: {
        ...nudgeData.nudgeCouponCode.customizeProperties,
        text: {
          ...nudgeData.nudgeCouponCode.customizeProperties.text,
          propertyValue: customizeState.nudgeCouponCode.text,
        },
        textColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.textColor,
          propertyValue: customizeState.nudgeCouponCode.textColor,
        },
        backgroundColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudgeCouponCode.backgroundColor,
        },
        fontStyle: {
          ...nudgeData.nudgeCouponCode.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeCouponCode.fontStyle,
        },
        shape: {
          ...nudgeData.nudgeClosed.customizeProperties.shape,
          propertyValue: customizeState.nudgeClosed.shape,
        },
        width: {
          ...nudgeData.nudgeClosed.customizeProperties.width,
          propertyValue: customizeState.nudgeClosed.width,
        },
        positionMode: {
          ...nudgeData.nudgeClosed.customizeProperties.positionMode,
          propertyValue: customizeState.nudgeClosed.positionMode,
        },
        height: {
          ...nudgeData.nudgeClosed.customizeProperties.height,
          propertyValue: customizeState.nudgeClosed.height,
        },
        padding: {
          ...nudgeData.nudgeClosed.customizeProperties.padding,
          propertyValue: customizeState.nudgeClosed.padding,
        },
        backgroundColor: {
          ...nudgeData.nudgeClosed.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudgeClosed.backgroundColor,
        },
        borderColor: {
          ...nudgeData.nudgeClosed.customizeProperties.borderColor,
          propertyValue: customizeState.nudgeClosed.borderColor,
        },
        borderWidth: {
          ...nudgeData.nudgeClosed.customizeProperties.borderWidth,
          propertyValue: customizeState.nudgeClosed.borderWidth,
        },
        borderStyle: {
          ...nudgeData.nudgeClosed.customizeProperties.borderStyle,
          propertyValue: customizeState.nudgeClosed.borderStyle,
        },
        borderRadius: {
          ...nudgeData.nudgeClosed.customizeProperties.borderRadius,
          propertyValue: customizeState.nudgeClosed.borderRadius,
        },
        shadowEnabled: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowEnabled,
          propertyValue: customizeState.nudgeClosed.shadowEnabled,
        },
        shadowColor: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowColor,
          propertyValue: customizeState.nudgeClosed.shadowColor,
        },
        shadowX: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowX,
          propertyValue: customizeState.nudgeClosed.shadowX,
        },
        shadowY: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowY,
          propertyValue: customizeState.nudgeClosed.shadowY,
        },
        shadowBlur: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowBlur,
          propertyValue: customizeState.nudgeClosed.shadowBlur,
        },
        shadowSpread: {
          ...nudgeData.nudgeClosed.customizeProperties.shadowSpread,
          propertyValue: customizeState.nudgeClosed.shadowSpread,
        },
        borderStyle: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderStyle,
          propertyValue: customizeState.nudgeCouponCode.borderStyle,
        },
        borderColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderColor,
          propertyValue: customizeState.nudgeCouponCode.borderColor,
        },
        borderWidth: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderWidth,
          propertyValue: customizeState.nudgeCouponCode.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderRadius,
          propertyValue: customizeState.nudgeCouponCode.borderRadius,
        },
        display: {
          ...nudgeData.nudgeCouponCode.customizeProperties.display,
          propertyValue: customizeState.nudgeCouponCode.display,
        },
        ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
          href: {
            ...nudgeData.nudgeCopyCode.customizeProperties.href,
            propertyValue: customizeState.nudgeCopyCode.href,
          }
        }),
      },
    },
    nudgeCopyCode: {
      ...nudgeData.nudgeCopyCode,
      customizeProperties: {
        ...nudgeData.nudgeCopyCode.customizeProperties,
        text: {
          ...nudgeData.nudgeCopyCode.customizeProperties.text,
          propertyValue: customizeState.nudgeCopyCode.text,
        },
        textColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.textColor,
          propertyValue: customizeState.nudgeCopyCode.textColor,
        },
        backgroundColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudgeCopyCode.backgroundColor,
        },
        fontStyle: {
          ...nudgeData.nudgeCopyCode.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeCopyCode.fontStyle,
        },
        borderStyle: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderStyle,
          propertyValue: customizeState.nudgeCopyCode.borderStyle,
        },
        borderColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderColor,
          propertyValue: customizeState.nudgeCopyCode.borderColor,
        },
        borderWidth: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderWidth,
          propertyValue: customizeState.nudgeCopyCode.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderRadius,
          propertyValue: customizeState.nudgeCopyCode.borderRadius,
        },
      },
    },
    nudge: {
      ...nudgeData.nudge,
      customizeProperties: {
        ...nudgeData.nudge.customizeProperties,
        backgroundColor: {
          ...nudgeData.nudge.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudge.backgroundColor,
        },
        borderColor: {
          ...nudgeData.nudge.customizeProperties.borderColor,
          propertyValue: customizeState.nudge.borderColor,
        },
        borderStyle: {
          ...nudgeData.nudge.customizeProperties.borderStyle,
          propertyValue: customizeState.nudge.borderStyle,
        },
        borderWidth: {
          ...nudgeData.nudge.customizeProperties.borderWidth,
          propertyValue: customizeState.nudge.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudge.customizeProperties.borderRadius,
          propertyValue: customizeState.nudge.borderRadius,
        },
      },
      nudgePosition: {
        ...nudgeData.nudge.nudgePosition,
        desktop: {
          ...nudgeData.nudge.nudgePosition.desktop,
          top: nudgePosition.desktop.top,
          left: nudgePosition.desktop.left,
        },
        mobile: {
          ...nudgeData.nudge.nudgePosition.mobile,
          top: nudgePosition.mobile.top,
        },
      },
    },
    nudgeShowing: {
      ...nudgeData.nudgeShowing,
      customizeProperties: {
        ...nudgeData.nudgeShowing.customizeProperties,
        allowed: {
          ...nudgeData.nudgeShowing.customizeProperties.allowed,
          propertyValue: (customizeState.nudgeShowing.allowed === undefined || customizeState.nudgeShowing.allowed.length === 0 || customizeState.nudgeShowing.allowed === "") ? [] : customizeState.nudgeShowing.allowed
        },
        prohibited: {
          ...nudgeData.nudgeShowing.customizeProperties.prohibited,
          propertyValue: customizeState.nudgeShowing.prohibited
        },
        status: {
          ...nudgeData.nudgeShowing.customizeProperties.status,
          propertyValue: customizeState.nudgeShowing.status
        },
        firstTimeNudgeShown: {
          ...nudgeData.nudgeShowing.customizeProperties.firstTimeNudgeShown,
          propertyValue: customizeState.nudgeShowing.firstTimeNudgeShown
        },
        sensitivity: {
          ...nudgeData.nudgeShowing.customizeProperties.sensitivity,
          propertyValue: customizeState.nudgeShowing.sensitivity,
        },
        device: {
          ...nudgeData.nudgeShowing.customizeProperties?.device,
          propertyValue: customizeState.nudgeShowing.device,
        },
        nudgeTimeout: {
          ...nudgeData.nudgeShowing.customizeProperties?.nudgeTimeout,
          propertyValue: customizeState.nudgeShowing.nudgeTimeout,
        },
        Geolocation: {
          ...nudgeData.nudgeShowing.customizeProperties.Geolocation,
          propertyValue: customizeState.nudgeShowing.Geolocation,
        },
        audience: {
          ...nudgeData.nudgeShowing.customizeProperties.audience,
          propertyValue: customizeState.nudgeShowing.audience,
        },
        ...(nudgeData.nudgeShowing.customizeProperties.startDate && {
          startDate: {
            ...nudgeData.nudgeShowing.customizeProperties.startDate,
            propertyValue: customizeState.nudgeShowing.startDate,
          }
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
          endDate: {
            ...nudgeData.nudgeShowing.customizeProperties.endDate,
            propertyValue: customizeState.nudgeShowing.endDate,
          }
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
          nudgeActiveDays: {
            ...nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays,
            propertyValue: customizeState.nudgeShowing.nudgeActiveDays,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
          GeoZipcodes: {
            ...nudgeData.nudgeShowing.customizeProperties.GeoZipcodes,
            propertyValue: customizeState.nudgeShowing.GeoZipcodes,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes && {
          BlacklistedZipcodes: {
            ...nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes,
            propertyValue: customizeState.nudgeShowing.BlacklistedZipcodes,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
          seoKeyword: {
            ...nudgeData.nudgeShowing.customizeProperties.seoKeyword,
            propertyValue: customizeState.nudgeShowing.seoKeyword,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
          ipBasedNudgeControl: {
            ...nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl,
            propertyValue: customizeState.nudgeShowing.ipBasedNudgeControl,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
          firstTimeUserCheckingOptions: {
            ...nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions,
            propertyValue: customizeState.nudgeShowing.firstTimeUserCheckingOptions,
          },
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.allowWebsiteClick && {
          allowWebsiteClick: {
            ...nudgeData.nudgeShowing.customizeProperties.allowWebsiteClick,
            propertyValue: nudgeData.nudgeShowing.customizeProperties.allowWebsiteClick?.propertyValue,
          }
        }),

      }
    },
    nudgePosition: {
      ...nudgeData.nudgePosition,
      customizeProperties: {
        ...nudgeData.nudgePosition.customizeProperties,
        margin_left: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_left,
          propertyValue: customizeState.nudgePosition.margin_left,
        },
        margin_top: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_top,
          propertyValue: customizeState.nudgePosition.margin_top,
        },
        margin_right: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_right,
          propertyValue: customizeState.nudgePosition.margin_right,
        },
        margin_bottom: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_bottom,
          propertyValue: customizeState.nudgePosition.margin_bottom,
        },
        placement: {
          ...nudgeData.nudgePosition.customizeProperties?.placement,
          propertyValue: customizeState.nudgePosition.placement,
        },
      }
    },
    ...(customizeState.nudgeTutorialVideo && {
      nudgeTutorialVideo: {
        ...nudgeData.nudgeTutorialVideo,
        customizeProperties: {
          ...nudgeData.nudgeTutorialVideo.customizeProperties,
          display: {
            ...nudgeData.nudgeTutorialVideo.customizeProperties.display,
            propertyValue: customizeState.nudgeTutorialVideo.display,
          },
          text: {
            ...nudgeData.nudgeTutorialVideo.customizeProperties.text,
            propertyValue: customizeState.nudgeTutorialVideo.text,
          },
          textColor: {
            ...nudgeData.nudgeTutorialVideo.customizeProperties.textColor,
            propertyValue: customizeState.nudgeTutorialVideo.textColor,
          },
          fontStyle: {
            ...nudgeData.nudgeTutorialVideo.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeTutorialVideo.fontStyle,
          },
          ...(nudgeData.nudgeTutorialVideo.customizeProperties.href && {
            href: {
              ...nudgeData.nudgeTutorialVideo.customizeProperties.href,
              propertyValue: customizeState.nudgeTutorialVideo.href,
            },
            linkText: {
              ...nudgeData.nudgeTutorialVideo.customizeProperties.linkText,
              propertyValue: customizeState.nudgeTutorialVideo.linkText,
            },
            linkTextColor: {
              ...nudgeData.nudgeTutorialVideo.customizeProperties.linkTextColor,
              propertyValue: customizeState.nudgeTutorialVideo.linkTextColor,
            },
          }),
        },
      },
    }),
  }

  console.log("handleSaveFirstTimeNudge -> state", state);

  set(ref(db, `${user}/customise_nudge/userNudgeData/${nudgeName}`), state)
    .then(() => {
      handleToast("success", "Saved Successfully!");
    })
    .catch((err) => {
      console.log(err);
      handleToast("error", "Try after sometimes!");
    });
};